import {useState} from 'react';
import ArchiveForm from '../../components/Forms/ArchiveForm';
import IternetForm from '../../components/Forms/InternetForm';
import MonoForm from '../../components/Forms/MonoForm';
import PeriodForm from '../../components/Forms/PeriodForm';
import StudyForm from '../../components/Forms/StudyForm';
import ZborPrimForm from '../../components/Forms/ZborPrimForm';
import ZborSecForm from '../../components/Forms/ZborSecForm';
import SelectBookType from '../../components/selectBookType/SelectBookType';

function NewEntryPage() {
    // 0 - Select type
    // 1 - Monografia
    // 2 - Zbornik primarny
    // 3 - Zbornik sekundarny
    // 4 - Studia  v niecom
    // 5 - Periodikum
    // 6 - Internet
    // 7 - Archiv
    const [pageState, setPageState] = useState(0);
    const [success, setSuccess] = useState(false);

    return (
        <div className='mainCont min-h-[100vh]'>
            {pageState === 0 && (
                <div>
                    <SelectBookType setPageState={setPageState} success={success} setSuccess={setSuccess}/>
                </div>
            )}
            {pageState === 1 && (<MonoForm setPageState={setPageState} setSuccess={setSuccess}/>)}
            {pageState === 2 && (<ZborPrimForm setPageState={setPageState} setSuccess={setSuccess}/>)}
            {pageState === 3 && (<ZborSecForm setPageState={setPageState} setSuccess={setSuccess}/>)}
            {pageState === 4 && (<StudyForm setPageState={setPageState} setSuccess={setSuccess}/>)}
            {pageState === 5 && (<PeriodForm setPageState={setPageState} setSuccess={setSuccess}/>)}
            {pageState === 6 && (<IternetForm setPageState={setPageState} setSuccess={setSuccess}/>)}
            {pageState === 7 && (<ArchiveForm setPageState={setPageState} setSuccess={setSuccess}/>)}
        </div>
    );
}

export default NewEntryPage;
